import { FlaskConical } from 'lucide-react';
import { useFeatureFlags } from '../lib/featureFlags';

/**
 * Persistent global indicator that the app is currently running in test mode.
 * Rendered in `AppShell` so it shows on every authenticated screen, including
 * the fullscreen wizard. Compact bar so it doesn't eat too much real estate.
 */
export function TestModeBanner() {
  const flags = useFeatureFlags();
  if (!flags.testMode) return null;
  return (
    <div className="bg-warning/15 border-b border-warning/30 text-warning px-3 py-1.5 flex items-center justify-center gap-2 text-meta font-bold tracking-wide">
      <FlaskConical className="h-3.5 w-3.5" strokeWidth={2.4} />
      Mode test actif — les fiches créées peuvent être incomplètes et le SMS peut être bypassé.
    </div>
  );
}
